import { render, staticRenderFns } from "./CxVisualPresentationIcon.vue?vue&type=template&id=b9835cbc&"
import script from "./CxVisualPresentationIcon.vue?vue&type=script&lang=js&"
export * from "./CxVisualPresentationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports